import { useEffect, useRef, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { MotionConfig, motion } from "framer-motion";
import Lenis from "lenis";
import "lenis/dist/lenis.css";
import { Toaster } from "sonner";
import { Nav } from "@/components/site/Nav";
import { Footer } from "@/components/site/Footer";
import { OrderProvider } from "@/components/site/OrderContext";
import { EASE } from "@/components/site/motion";

const WIPES = ["#ff2e63", "#ff7a00", "#2e9e4f", "#8b6cf2", "#ffd23f"];

const PageWipe = ({ pathname }) => {
  const [first] = useState(pathname);
  const moved = useRef(false);
  if (pathname !== first) moved.current = true;
  if (!moved.current) return null;
  return (
    <motion.div
      key={pathname}
      aria-hidden
      className="pointer-events-none fixed inset-0 z-[95] origin-top"
      style={{ background: WIPES[pathname.length % WIPES.length] }}
      initial={{ scaleY: 1 }}
      animate={{ scaleY: 0 }}
      transition={{ duration: 0.7, ease: EASE }}
    />
  );
};

export default function Layout() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.1, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <MotionConfig reducedMotion="user">
      <OrderProvider>
        <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[200] focus:rounded-full focus:bg-white focus:px-4 focus:py-2">Skip to content</a>
        <Nav />
        <PageWipe pathname={pathname} />
        <main id="main">
          <Outlet />
        </main>
        <Footer />
        <Toaster position="bottom-center" richColors />
      </OrderProvider>
    </MotionConfig>
  );
}
